module.exports = __webpack_public_path__ + "static/media/racial_diversity_in_us.c24e84c5.jpg";